import React, { useState } from 'react';
import { BottomSheet } from '../ui/BottomSheet';
interface AddHabitSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void;
}
export function AddHabitSheet({
  isOpen,
  onClose,
  onSubmit
}: AddHabitSheetProps) {
  const [name, setName] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
    setName('');
    onClose();
  };
  return <BottomSheet isOpen={isOpen} onClose={onClose} title="New habit" data-id="element-43" data-mp="6g3q0aoyeilo">
      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-44" data-mp="k6pag3u230lo">
        <div data-id="element-45" data-mp="k8a842bo2znr">
          <label htmlFor="habit-name" className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-46" data-mp="k8tpnhxenm19">
            What do you want to track?
          </label>
          <input id="habit-name" type="text" value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Drink 8 glasses of water" autoFocus className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-100" data-id="element-47" data-mp="3nuqxo0dujs8w" />
        </div>
        <button type="submit" disabled={!name.trim()} className="w-full rounded-xl bg-teal-600 py-3 text-sm font-semibold text-white transition-colors duration-150 hover:bg-teal-700 disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-400" data-id="element-48" data-mp="192v8onv0t592">
          Add habit
        </button>
      </form>
    </BottomSheet>;
}